import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject, firstValueFrom, from } from "rxjs";
import { switchMap, take } from 'rxjs/operators';
import { EndpointService } from 'src/app/core/services/endpoint.service';
import { Empresa } from "src/app/refact/pages/components/redes/classes/empresa";
import { NotificacaoSessionStorage } from "src/app/refact/shared/components/notificacoes/entities/notificacao-session-storage";
import { ReturnPack } from "src/app/shared/returnPack";
import { environment as env } from "../../../../environments/environment";
import { User } from "../entities/user";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  loggedInStatus: boolean = JSON.parse(
    localStorage.getItem("loggedIn") || "false"
  );
  private logger = new Subject<boolean>();

  private readonly URLTOKEN: string = "connect/token";
  public readonly URLPROFILE: string = "user/profile";
  private readonly URLDISCOVERY: string = "api/webserver";
  private readonly REDES: string = "api/v1/Empresa/versao/0";
  private readonly POUCHENVIRONMENT: string = "api/v1/AmbienteMalote/";
  private readonly URLDISCO: string = "sys/disco";
  private readonly EMPRESA: string = "api/v1/Empresa";
  private readonly AMBIENTE_STORAGE_KEY: string = "ambiente";

  private readonly CONSULTAR: string = "CONSULTAR";
  private readonly INCLUIR: string = "INCLUIR";
  private readonly ALTERAR: string = "ALTERAR";
  private readonly DELETAR: string = "DELETAR";
  private readonly ALL: string = "ALL";

  public authUrl : string;
  
  constructor(private _http: HttpClient, private _router: Router, private endpointService: EndpointService) {
    if (!this.isLoggedIn) {
      sessionStorage.setItem(
        NotificacaoSessionStorage.ALERTA_NOTIFICACOES,
        "true"
      );
    }
  }

  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
    localStorage.setItem("loggedIn", "true");
    this.logger.next(this.loggedInStatus);
  }

  get isLoggedIn() {
    return JSON.parse(
      (localStorage.getItem("loggedIn") || this.loggedInStatus.toString()) &&
        localStorage.getItem("modulos")
    );
  }

  temVinculoUsuario(): boolean {
    try {
      const ambienteRaw = localStorage.getItem(this.AMBIENTE_STORAGE_KEY);
      if (!ambienteRaw) return false;

      const ambiente = JSON.parse(ambienteRaw);
      return !!ambiente?.matriculaUsuario;
    } catch {
      return false;
    }
  }

  get authProtocol()
  {
    return this.authUrl.substring(0, this.authUrl.indexOf(":")-1)
  }

  async getAuth()
  
  {
    const ret: any = await firstValueFrom(
      this._http.get(this.endpointService.getMaestroUrl() + this.URLDISCO )
    );
    
    if(ret)
      {
        var urlAuth = ret.authHost;      
        if(urlAuth.lastIndexOf("/") != urlAuth.length-1)
          urlAuth = urlAuth + "/";
          
        this.authUrl = urlAuth;
      }                
  }

  getToken(user: User): Observable<any> {
    const PARAMS = new HttpParams()
      .set("grant_type", "client_credentials")
      .set(
        "scope",
        "APISalesModule APISupplyModule ReportViewModule MaestroServer APIPurchaseModule APILogisticModule APICRMModule APIPriceModule APIHumanResourcesModule APIeCommerceModule APIReceberModule APIInfrastructureModule APISincroniza APIFinancialModule APITributaryModule"
      )
      .set("client_id", user.client_id)
      .set("client_secret", user.client_secret);
    
    
    return this._http.post<User>(
      this.authUrl + this.URLTOKEN,
      PARAMS.toString(),
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded"
        ),
      }
    );
  }

  getProfile(): Observable<any> {
    if (!this.authUrl) {
      return from(this.getAuth()).pipe(
        switchMap(() => this._http.get(this.authUrl + this.URLPROFILE))
      );
    } else {
      return this._http.get(this.authUrl + this.URLPROFILE);
    }
  }

  getDiscovery(idCliente: string, idModule: number): Observable<any> {
    return this._http.get(
        this.endpointService.getMaestroUrl() + this.URLDISCOVERY + "/" + idCliente + "/1/" + idModule
    );
  }

  testeMaestro(): Observable<boolean> {
    return this._http.get<boolean>(this.endpointService.getMaestroUrl() + "sys/ping");
  }

  testeGuardian(): Observable<boolean> {
    return this._http.get<boolean>(this.authUrl + "sys/ping");
  }

  doLogout(reload: boolean = true) {
    this.limpaLocalStorage();
    this.logger.next(this.loggedInStatus);

    if (reload) {
      window.location.reload();
    }
  }

  limpaSessionStorage() {
    sessionStorage.clear();
    sessionStorage.setItem(
      NotificacaoSessionStorage.ALERTA_NOTIFICACOES,
      "true"
    );
  }

  limpaLocalStorage() {
    let configuracao = localStorage.getItem("configuracao");
    const impressao = localStorage.getItem("impressao");
    const impressoratermica = localStorage.getItem("impressoratermica"); // nome da impressora 80mm
    const impressorapadrao  = localStorage.getItem("impressorapadrao");  // chave legada (migração)
    const impressoraa4 = localStorage.getItem("impressoraa4");
    const definicoesFiltragemProduto = localStorage.getItem("definicoesFiltragemProduto");
    const simularPdvup = localStorage.getItem("simular-pdvup");
    localStorage.clear();
    configuracao ? localStorage.setItem("configuracao", configuracao) : null;
    impressao ? localStorage.setItem("impressao", impressao) : null;
    impressoratermica
      ? localStorage.setItem("impressoratermica", impressoratermica)
      : null;
    // Preservar chave legada até que a migração automática ocorra na próxima leitura
    impressorapadrao && !impressoratermica
      ? localStorage.setItem("impressorapadrao", impressorapadrao)
      : null;
    impressoraa4
      ? localStorage.setItem("impressoraa4", impressoraa4)
      : null;
    definicoesFiltragemProduto
      ? localStorage.setItem("definicoesFiltragemProduto", definicoesFiltragemProduto)
      : null;
    simularPdvup
      ? localStorage.setItem("simular-pdvup", simularPdvup)
      : null;
  }

  getAcess(PosAcess: number) {
    const access = new String(localStorage.getItem("user_access"));
    let ret: any = false;
    if (access.length >= PosAcess) {
      switch (PosAcess) {
        case 198:
          ret = access.substring(PosAcess - 1, PosAcess);
          break;
        case 199:
          ret = access.substring(PosAcess - 1, PosAcess);
          break;
        case 200:
          ret = access.substring(PosAcess - 1, PosAcess);
          break;
        default:
          if (Number(access.substring(PosAcess - 1, PosAcess)) >= 1) {
          
            ret = true;
          } else {
            ret = false;
          }
          break;
      }
    } else {
      ret = false;
    }
    
    return ret;
  }

  getAcessLevel(PosAcess: number) {
    let retorno = [];
    const access = new String(localStorage.getItem("user_access"));
    if (PosAcess && access.length >= PosAcess) {
      let acessoNumero = Number(access.substring(PosAcess - 1, PosAcess));
      switch (acessoNumero) {
        case 1:
          retorno.push(this.CONSULTAR);
          retorno.push(this.INCLUIR);
          retorno.push(this.ALTERAR);
          retorno.push(this.DELETAR);
          retorno.push(this.ALL);
          retorno.push(acessoNumero.toString());
          break;
        case 2:
          retorno.push(this.CONSULTAR);
          retorno.push(acessoNumero.toString());
          break;
        case 3:
          retorno.push(this.CONSULTAR);
          retorno.push(this.INCLUIR);
          retorno.push(acessoNumero.toString());
          break;
        case 4:
          retorno.push(this.CONSULTAR);
          retorno.push(this.INCLUIR);
          retorno.push(this.ALTERAR);
          retorno.push(acessoNumero.toString());
          break;
        case 5:
          retorno.push(this.CONSULTAR);
          retorno.push(this.INCLUIR);
          retorno.push(this.DELETAR);
          retorno.push(acessoNumero.toString());
          break;
        case 6:
          retorno.push(this.CONSULTAR);
          retorno.push(this.ALTERAR);
          retorno.push(acessoNumero.toString());
          break;
        case 7:
          retorno.push(this.CONSULTAR);
          retorno.push(this.ALTERAR);
          retorno.push(this.DELETAR);
          break;
        case 8:
          retorno.push(this.CONSULTAR);
          retorno.push(this.DELETAR);
          break;
        default:
          break;
      }
    }
    return retorno;
  }

  getRedes() {
    return this._http.get(
      localStorage.getItem(env.baseApiModuleLogistic.toString()) + this.REDES
    );
  }

  obterRedesPermitidasUsuario(matricula: string): Observable<ReturnPack<Empresa[]>> {
    return this._http
      .get<ReturnPack>(
        localStorage.getItem(env.baseApiModuleLogistic.toString()) +
        this.EMPRESA + "/usuario/" + matricula)
      .pipe(take(1));
  }

  getPouchEnvironment() {
    return this._http.get(
      localStorage.getItem(env.baseApiModuleEcommerce.toString()) +
        this.POUCHENVIRONMENT
    );
  }
}
